module.exports = __webpack_public_path__ + "img/boukaih-bGMyTnSlYvE-unsplash.5c45c9bc.jpg";